export const SAVE_SELECTED_PRODUCT = 'SAVE_SELECTED_PRODUCT';